<template>
    <report-list-item :class="namespaceClass()" :text="text" :checked="checked" :disabled="disabled" @report-status-change="handleReportStatusChanged">
        <mds-form>
            <mds-layout-grid>
                <mds-row>
                    <mds-col :cols="12" :cols-at-s="12" :cols-at-m="12" :cols-at-l="12" :cols-at-xl="12">
                        <mds-input
                            :class="namespaceClass('__title')"
                            :label="getUILabel('report_generator_cover_page_report_title_label')"
                            v-model="reportTitle"
                        >
                        </mds-input>
                    </mds-col>
                    <mds-col :class="namespaceClass('__prepared_col')" :cols="12" :cols-at-s="12" :cols-at-m="6" :cols-at-l="6" :cols-at-xl="6">
                        <div :class="namespaceClass('__additional-info-item')">
                            <div :class="namespaceClass('__subheader')">
                                <mds-icon name="person"></mds-icon>
                                <span :class="namespaceClass('__subheader-title')">{{
                                    this.getUILabel("report_generator_cover_page_prepared_for_label")
                                }}</span>
                            </div>
                            <mds-fieldset :microcopy-above="optionalFieldsTip" :class="namespaceClass('__field-tip')" size="small"> </mds-fieldset>
                            <mds-fieldset horizontal>
                                <mds-input v-model="preparedForFirstName" :label="firstNameLabel" :maxlength="inputCharactersMaxLength"> </mds-input>
                                <mds-input v-model="preparedForLastName" :label="lastNameLabel" :maxlength="inputCharactersMaxLength"> </mds-input>
                            </mds-fieldset>
                            <mds-input v-model="preparedForAddress" :label="addressLabel" :maxlength="inputCharactersMaxLength"> </mds-input>
                            <mds-fieldset horizontal>
                                <mds-input v-model="preparedForCity" :label="cityLabel" :maxlength="inputCharactersMaxLength" :class="namespaceClass('__city')">
                                </mds-input>
                                <template v-if="isState">
                                    <template v-if="stateList.length > 0">
                                        <mds-combo-box :class="namespaceClass('__state')" :label="stateLabel" :data-set="stateList" v-model="preparedForState">
                                        </mds-combo-box>
                                    </template>
                                </template>
                                <template v-else>
                                    <mds-input
                                        :class="namespaceClass('__province')"
                                        v-model="preparedForState"
                                        :label="provinceLabel"
                                        :maxlength="inputCharactersMaxLength"
                                    >
                                    </mds-input>
                                </template>
                                <mds-input
                                    :class="namespaceClass('__zip')"
                                    v-model="preparedForZipCode"
                                    :label="zipLabel"
                                    :maxlength="inputCharactersMaxLength"
                                >
                                </mds-input>
                            </mds-fieldset>
                            <mds-fieldset horizontal>
                                <template v-if="showCoverPageCountry">
                                    <mds-input v-model="preparedForCountry" :label="countryLabel" :maxlength="inputCharactersMaxLength"> </mds-input>
                                </template>
                                <mds-input v-model="preparedForPhone" :label="phoneLabel" :maxlength="inputCharactersMaxLength"> </mds-input>
                            </mds-fieldset>
                            <mds-fieldset>
                                <mds-input v-model="preparedForEmail" :label="emailLabel" :maxlength="inputCharactersMaxLength"> </mds-input>
                            </mds-fieldset>
                        </div>
                    </mds-col>
                    <mds-col :class="namespaceClass('__prepared_col')" :cols="12" :cols-at-s="12" :cols-at-m="6" :cols-at-l="6" :cols-at-xl="6">
                        <div :class="namespaceClass('__additional-info-item')">
                            <div :class="namespaceClass('__subheader')">
                                <mds-icon name="person"></mds-icon>
                                <span :class="namespaceClass('__subheader-title')">{{ this.getUILabel("report_generator_cover_page_prepared_by_label") }}</span>
                            </div>
                            <mds-fieldset :microcopy-above="optionalFieldsTip" :class="namespaceClass('__field-tip')" size="small"> </mds-fieldset>
                            <mds-fieldset horizontal>
                                <mds-input v-model="preparedByFirstName" :label="firstNameLabel" :maxlength="inputCharactersMaxLength"> </mds-input>
                                <mds-input v-model="preparedByLastName" :label="lastNameLabel" :maxlength="inputCharactersMaxLength"> </mds-input>
                            </mds-fieldset>
                            <mds-input v-model="preparedByAddress" :label="addressLabel" :maxlength="inputCharactersMaxLength"> </mds-input>
                            <mds-fieldset horizontal>
                                <mds-input v-model="preparedByCity" :label="cityLabel" :maxlength="inputCharactersMaxLength" :class="namespaceClass('__city')">
                                </mds-input>
                                <template v-if="isState">
                                    <template v-if="stateList.length > 0">
                                        <mds-combo-box :class="namespaceClass('__state')" :label="stateLabel" :data-set="stateList" v-model="preparedByState">
                                        </mds-combo-box>
                                    </template>
                                </template>
                                <template v-else>
                                    <mds-input
                                        :class="namespaceClass('__province')"
                                        v-model="preparedByState"
                                        :label="provinceLabel"
                                        :maxlength="inputCharactersMaxLength"
                                    >
                                    </mds-input>
                                </template>
                                <mds-input :class="namespaceClass('__zip')" v-model="preparedByZipCode" :label="zipLabel" :maxlength="inputCharactersMaxLength">
                                </mds-input>
                            </mds-fieldset>
                            <mds-fieldset horizontal>
                                <template v-if="showCoverPageCountry">
                                    <mds-input v-model="preparedByCountry" :label="countryLabel" :maxlength="inputCharactersMaxLength"> </mds-input>
                                </template>
                                <mds-input v-model="preparedByPhone" :label="phoneLabel" :maxlength="inputCharactersMaxLength"> </mds-input>
                            </mds-fieldset>
                            <mds-fieldset>
                                <mds-input v-model="preparedByEmail" :label="emailLabel" :maxlength="inputCharactersMaxLength"> </mds-input>
                            </mds-fieldset>
                        </div>
                    </mds-col>
                </mds-row>
            </mds-layout-grid>
        </mds-form>
    </report-list-item>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import ReportListItem from "./ReportListItem";
import * as types from "../../store/mutation-types";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import MdsForm from "@mds/form";
import MdsFieldset from "@mds/fieldset";
import MdsInput from "@mds/input";
import MdsIcon from "@mds/icon";
import MdsComboBox from "@mds/combo-box";
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";

export default {
    name: "cover-report",
    props: {
        text: {
            type: String,
            default: ""
        },
        checked: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        },
        reportSettings: {
            type: Object
        }
    },
    components: {
        ReportListItem,
        MdsForm,
        MdsFieldset,
        MdsComboBox,
        MdsInput,
        MdsIcon,
        MdsLayoutGrid,
        MdsRow,
        MdsCol
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            }
        };
    },
    computed: {
        inputCharactersMaxLength() {
            return 100;
        },
        stateList() {
            return this.$store.getters["reportSetting/stateList"];
        },
        optionalFieldsTip() {
            return this.getUILabel("report_generator_cover_page_optional_fields_tip");
        },
        firstNameLabel() {
            return this.getUILabel("report_generator_cover_page_first_name_label");
        },
        lastNameLabel() {
            return this.getUILabel("report_generator_cover_page_last_name_label");
        },
        addressLabel() {
            return this.getUILabel("report_generator_cover_page_address_label");
        },
        cityLabel() {
            return this.getUILabel("report_generator_cover_page_city_label");
        },
        stateLabel() {
            return this.getUILabel("report_generator_cover_page_state_label");
        },
        provinceLabel() {
            return this.getUILabel("report_generator_cover_page_province_label");
        },
        zipLabel() {
            return this.getUILabel("report_generator_cover_page_zip_label");
        },
        countryLabel() {
            return this.getUILabel("report_generator_cover_page_country_label");
        },
        phoneLabel() {
            return this.getUILabel("report_generator_cover_page_phone_label");
        },
        emailLabel() {
            return this.getUILabel("report_generator_cover_page_email_label");
        },
        showCoverPageCountry() {
            return this.$store.getters["config/showCountry"];
        },
        stateOrProvince() {
            return this.$store.getters["config/stateOrProvince"];
        },
        isState() {
            return this.stateOrProvince === "state";
        },
        reportTitle: {
            get() {
                return this.reportSettings.reportTitle;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_REPORT_TITLE}`);
            }
        },
        preparedForFirstName: {
            get() {
                return this.reportSettings.preparedForFirstName;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_FOR_FIRST_NAME}`);
            }
        },
        preparedForLastName: {
            get() {
                return this.reportSettings.preparedForLastName;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_FOR_LAST_NAME}`);
            }
        },
        preparedForAddress: {
            get() {
                return this.reportSettings.preparedForAddress;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_FOR_ADDRESS}`);
            }
        },
        preparedForCity: {
            get() {
                return this.reportSettings.preparedForCity;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_FOR_CITY}`);
            }
        },
        preparedForState: {
            get() {
                const preparedForState = this.reportSettings.preparedForState || "";
                return this.isState ? [preparedForState.toLowerCase()] : preparedForState;
            },
            set(value) {
                const modelValue = this.isState ? (value[0] || "").toLowerCase() : value;
                this.handleReportSettingChanged(modelValue, `${types.SET_PREPARED_FOR_STATE}`);
            }
        },

        preparedForZipCode: {
            get() {
                return this.reportSettings.preparedForZipCode;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_FOR_ZIP_CODE}`);
            }
        },
        preparedForCountry: {
            get() {
                return this.reportSettings.preparedForCountry;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_FOR_COUNTRY}`);
            }
        },
        preparedForPhone: {
            get() {
                return this.reportSettings.preparedForPhone;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_FOR_PHONE}`);
            }
        },
        preparedForEmail: {
            get() {
                return this.reportSettings.preparedForEmail;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_FOR_EMAIL}`);
            }
        },
        preparedByFirstName: {
            get() {
                return this.reportSettings.preparedByFirstName;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_BY_FIRST_NAME}`);
            }
        },
        preparedByLastName: {
            get() {
                return this.reportSettings.preparedByLastName;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_BY_LAST_NAME}`);
            }
        },
        preparedByAddress: {
            get() {
                return this.reportSettings.preparedByAddress;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_BY_ADDRESS}`);
            }
        },
        preparedByCity: {
            get() {
                return this.reportSettings.preparedByCity;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_BY_CITY}`);
            }
        },
        preparedByState: {
            get() {
                const preparedByState = this.reportSettings.preparedByState || "";
                return this.isState ? [preparedByState.toLowerCase()] : preparedByState;
            },
            set(value) {
                const modelValue = this.isState ? (value[0] || "").toLowerCase() : value;
                this.handleReportSettingChanged(modelValue, `${types.SET_PREPARED_BY_STATE}`);
            }
        },
        preparedByZipCode: {
            get() {
                return this.reportSettings.preparedByZipCode;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_BY_ZIP_CODE}`);
            }
        },
        preparedByCountry: {
            get() {
                return this.reportSettings.preparedByCountry;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_BY_COUNTRY}`);
            }
        },
        preparedByPhone: {
            get() {
                return this.reportSettings.preparedByPhone;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_BY_PHONE}`);
            }
        },
        preparedByEmail: {
            get() {
                return this.reportSettings.preparedByEmail;
            },
            set(value) {
                this.handleReportSettingChanged(value, `${types.SET_PREPARED_BY_EMAIL}`);
            }
        }
    },
    methods: {
        handleReportStatusChanged(e) {
            this.$emit("report-status-change", e);
        },
        handleReportSettingChanged(data, mutation) {
            this.$store.commit(`reportSetting/${mutation}`, data);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@mds/typography";
.cover-report {
    form {
        border-top: 1px solid $mds-color-neutral-90;
        .mds-layout-grid__row___hypo {
            margin: 0;
        }
    }

    &__title {
        ::v-deep .mds-label__text___hypo {
            padding: 11px 0px 6px 0px;
            line-height: 1.375;
        }
    }

    &__prepared_col {
        max-width: 50%;
    }

    &__city {
        min-width: calc(50% - 6px);
    }

    &__additional-info-item {
        margin-bottom: 20px;
        ::v-deep .mds-label__text___hypo {
            font-size: $mds-typography-font-size-s;
        }
    }

    &__subheader {
        display: flex;
        padding: 14px 0px;
        border-bottom: 1px solid $mds-color-neutral-90;
        &-title {
            @include mds-body-text-l($bold: false);
            margin-left: 7px;
            color: $mds-color-neutral-12;
        }
    }

    &__field-tip {
        ::v-deep .mds-microcopy___hypo {
            padding: 10px 0px;
        }
    }

    &__state,
    &__province,
    &__zip {
        width: calc(25% - 12px);
    }
}
</style>
